import { hamtaDokument } from '../instruktionerApi';

/**
 * Skriver ut instruktionen. Dokumentet läggs i en dold, sandboxad ram utan
 * skriptbehörighet (samma skydd som i visaren) och ramens utskriftsdialog
 * öppnas. Instruktionens egen @page-CSS ger rätt A4 — "Spara som PDF" i
 * dialogen ger PDF:en.
 * @returns {Promise<void>}
 */
export async function skrivUt(nyckel) {
  const html = await hamtaDokument(nyckel);
  const ram = document.createElement('iframe');
  ram.setAttribute('sandbox', 'allow-same-origin allow-modals');
  ram.setAttribute('aria-hidden', 'true');
  ram.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  ram.srcdoc = html;
  await new Promise((klar) => { ram.onload = klar; document.body.appendChild(ram); });
  // Vänta in typsnittet så att utskriften inte tas med reservtypsnitt.
  try { await ram.contentDocument.fonts.ready; } catch { /* äldre webbläsare */ }
  ram.contentWindow.focus();
  ram.contentWindow.print();
  // Ta bort ramen när dialogen stängts (print() blockerar i de flesta webbläsare).
  setTimeout(() => ram.remove(), 1000);
}
